import { render } from "./PressRelease.vue?vue&type=template&id=92262dd0"
import script from "./PressRelease.vue?vue&type=script&lang=js"
export * from "./PressRelease.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__